import SendIcon from '@mui/icons-material/Send';
import { Tooltip } from '@mui/material';
import Fab from '@mui/material/Fab';
import Input from '@mui/material/Input';
import Slide from '@mui/material/Slide';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useKeyboardInput } from '../../hooks/useKeyboardInput';
import { selectIsTextToSpeechV2 } from '../../selectors/auth';
import { selectIsUsingTts } from '../../selectors/textToSpeech';
import { selectFontSize, selectKeyboardInputShown } from '../../selectors/ui';
import { useAppSelector } from '../../store/store';
import { Z_INDICES } from '../../styles';
import TtsButton from '../textToSpeech/TtsButton';
import V1TtsButton from '../textToSpeech/V1Button';
const useStyles = makeStyles((theme) => ({
    input: {
        position: 'absolute',
        bottom: 30,
        right: 160,
        width: 'calc(100% - 180px)',
        fontSize: (props) => props.fontSize,
    },
    fab: {
        position: 'absolute',
        bottom: 30,
        color: theme.palette.ava.white,
        zIndex: Z_INDICES.keyboardInputFab,
        '&:hover': {
            // I couldn't find a way to overwrite the behavior without !important
            // even in style/sx props of the component
            backgroundColor: `${theme.palette.ava.deepBlue} !important`,
        },
    },
}));
const KeyboardInput = () => {
    const fontSize = useAppSelector(selectFontSize);
    const classes = useStyles({ fontSize });
    const theme = useTheme();
    const { t } = useTranslation();
    const keyboardInputShown = useAppSelector(selectKeyboardInputShown);
    const isUsingTts = useAppSelector(selectIsUsingTts);
    const isTextToSpeechV2 = useAppSelector(selectIsTextToSpeechV2);
    const { message, onInputChange, onInputKeyDown, onSendClick } = useKeyboardInput();
    return (React.createElement(React.Fragment, null,
        keyboardInputShown && (React.createElement(Slide, { direction: "left", in: true, mountOnEnter: true, unmountOnExit: true },
            React.createElement(Input, { classes: { root: classes.input }, onChange: onInputChange, value: message, "data-qa": "ttsInputField", placeholder: t('conversation.typeTranscriptHere'), onKeyDown: onInputKeyDown, autoFocus: true, multiline: true, minRows: '1' }))),
        keyboardInputShown && isTextToSpeechV2 ? React.createElement(TtsButton, null) : keyboardInputShown && React.createElement(V1TtsButton, null),
        keyboardInputShown && (React.createElement(Tooltip, { title: !isUsingTts ? t('ccMode.keyboard.tooltip.send') : t('ccMode.keyboard.sendAsVoiceMessage') },
            React.createElement(Fab, { classes: { root: classes.fab }, "data-qa": "sendTTS", onClick: onSendClick, style: {
                    right: 20,
                    backgroundColor: theme.palette.ava.blue,
                } },
                React.createElement(SendIcon, null))))));
};
export default KeyboardInput;
